import { useQueryClient } from '@tanstack/react-query';
import { useApi } from './useApi';
import { useModeAwareMutation } from './useModeAwareQuery';

export interface LogSendCopyInvoiceRequest {
  customerId: number;
  recipientEmail: string;
  message?: string;
  transactionIds?: number[];
}

interface LogSendCopyInvoiceResponse {
  communicationId: number;
}

export function useLogSendCopyInvoice() {
  const { apiPost } = useApi();
  const queryClient = useQueryClient();

  return useModeAwareMutation<LogSendCopyInvoiceResponse, Error, LogSendCopyInvoiceRequest>(
    async (request) => {
      return apiPost<LogSendCopyInvoiceResponse>('/api/v1/transactions/log-send-copy-invoice', request);
    },
    async () => {
      return { communicationId: Date.now() };
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['recent-activities'] });
        queryClient.invalidateQueries({ queryKey: ['transactions'] });
      },
    },
  );
}
